import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'erro-importacao-dialog',
    templateUrl: './erro-importacao-dialog.component.html',
    styleUrls: ['./erro-importacao-dialog.component.css']
})
export class ErroImportacaoDialogComponent {

    constructor(
        private dialogRef: MatDialogRef<ErroImportacaoDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { observacoes: string; nomeArquivo?: string }
    ) {
    }

    fechar(): void {
        this.dialogRef.close();
    }
}
